import React from 'react';
import { Pencil, Trash } from '@phosphor-icons/react';
import { OverflowWrapper } from 'app/components';

export const COLUMN_CONFIG = [
  {
    'label': 'Organizer Name',
    'path': 'company_name',
    'order': 1,
    'field': 'company_name',
  },
  {
    'label': 'Organizer',
    'path': 'business_config_id',
    'order': 2,
    'field': 'business_config_id',
  },
  {
    'label': 'Address',
    'path': 'city',
    'order': 3,
    'field': 'city',
    rowElement: ({ row }) => (
      <OverflowWrapper>{row?.address_details?.address_line_1}</OverflowWrapper>
    ),
  },
  {
    'label': 'Created',
    'path': 'createdAt',
    'order': 6,
    isDate: true,
    'field': 'createdAt',
  },
  {
    'label': 'Status',
    'path': 'status',
    'order': 7,
    'field': 'status',
    rowElement: ({ row }) => (
      <div className={`${row?.is_active ? 'text-primary-green' : 'text-error'}`}>
        {row?.is_active ? 'APPROVED' : 'PENDING'}
      </div>
    ),
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 8,
    'field': 'action_items',
  },
];

export const ACTION_ITEMS = [
  { icon: <Pencil />, action: 'edit' },
  // { icon: <Trash />, action: 'delete' },
];
